"use strict";

var _defineProperty = require("/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _chunkT6SARJYHjs = require('./chunk.T6SARJYH.js');
var _htmlparser2 = require('htmlparser2');
var j = {
    lowerCaseTags: !1,
    lowerCaseAttributeNames: !1,
    decodeEntities: !1
  },
  v = [{
    name: "!doctype",
    start: "<",
    end: ">"
  }],
  I = exports.parser = function (d) {
    var f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var c = new (0, _chunkT6SARJYHjs.a)(d),
      i = [],
      s = [],
      p = 0;
    function a() {
      return i[i.length - 1];
    }
    function b(n, t) {
      return n.name instanceof RegExp ? new RegExp(n.name.source, "i").test(t) : t === n.name;
    }
    function y(n) {
      var t = {};
      return Object.keys(n).forEach(function (e) {
        var o = {};
        o[e] = String(n[e]).replace(/&quot;/g, '"'), Object.assign(t, o);
      }), t;
    }
    function x(n, t) {
      var g;
      var e = v.concat((g = f.directives) != null ? g : []),
        o = a();
      var _iterator = _createForOfIteratorHelper(e),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var u = _step.value;
          var l = u.start + t + u.end;
          if (b(u, n.toLowerCase())) {
            if (o === void 0) {
              s.push(l);
              return;
            }
            typeof o == "object" && (o.content === void 0 && (o.content = []), Array.isArray(o.content) && o.content.push(l));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    function A(n) {
      var t = a(),
        e = "<!--".concat(n, "-->");
      if (t === void 0) {
        s.push(e);
        return;
      }
      typeof t == "object" && (t.content === void 0 && (t.content = []), Array.isArray(t.content) && t.content.push(e));
    }
    function m(n, t) {
      var e = {
        tag: n
      };
      f.sourceLocations && (e.location = {
        start: c.getPosition(r.startIndex),
        end: c.getPosition(r.endIndex)
      }, p = r.endIndex), Object.keys(t).length > 0 && (e.attrs = y(t)), i.push(e);
    }
    function h(n, t) {
      var e = i.pop();
      if (e && typeof e == "object" && e.location && r.endIndex !== null && (t ? p < r.startIndex && (e.location.end = c.getPosition(r.startIndex - 1)) : e.location.end = c.getPosition(r.endIndex)), e) {
        var o = a();
        if (i.length <= 0) {
          s.push(e);
          return;
        }
        typeof o == "object" && (o.content === void 0 && (o.content = []), Array.isArray(o.content) && o.content.push(e));
      }
    }
    function N(n) {
      var t = a();
      if (t === void 0) {
        s.push(n);
        return;
      }
      if (typeof t == "object") {
        if (t.content && Array.isArray(t.content) && t.content.length > 0) {
          var e = t.content[t.content.length - 1];
          if (typeof e == "string" && !e.startsWith("<!--")) {
            t.content[t.content.length - 1] = "".concat(e).concat(n);
            return;
          }
        }
        t.content === void 0 && (t.content = []), Array.isArray(t.content) && t.content.push(n);
      }
    }
    var r = new (0, _htmlparser2.Parser)({
      onprocessinginstruction: x,
      oncomment: A,
      onopentag: m,
      onclosetag: h,
      ontext: N
    }, _objectSpread(_objectSpread({}, j), f));
    return r.write(d), r.end(), s;
  };
exports.parser = I;